// extracted by mini-css-extract-plugin
export var cartContainer = "_kd-4";
export var gray = "_kd-1";
export var itemContainer = "_kd-2";
export var itemDetails = "_kd-3";
export var strong = "_kd-0";